import Loading from '@/components/ui/Loading'
import { StepComponentProps } from '../types'

export function LoadingComponent({ step }: StepComponentProps) {
  return (
    <div className="flex flex-col gap-2 p-4">
      <h1 className="text-heading1 text-text">{step.title}</h1>
      {step.description && (
        <p className="text-regular text-text">{step.description}</p>
      )}
      <div className="flex flex-row justify-center p-4">
        <Loading />
      </div>
    </div>
  )
}
